import { render, staticRenderFns } from "./onlineReading.vue?vue&type=template&id=55184835&scoped=true&"
import script from "./onlineReading.vue?vue&type=script&lang=js&"
export * from "./onlineReading.vue?vue&type=script&lang=js&"
import style0 from "./onlineReading.vue?vue&type=style&index=0&id=55184835&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55184835",
  null
  
)

export default component.exports